// Google Consent Mode v2 helpers
// Consent is denied by default (initialised in index.html BEFORE gtag loads).
// After user interaction we update the state and persist to localStorage.

export const CONSENT_STORAGE_KEY = "ecominiere_consent_v2";

export const DEFAULT_CONSENT = {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
  functionality_storage: "granted",
  personalization_storage: "denied",
  security_storage: "granted",
};

function pushGtagConsent(state) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  // Push consent update in the exact shape gtag expects
  window.dataLayer.push(["consent", "update", state]);
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", state);
  }
  window.dataLayer.push({ event: "cookie_consent_update" });
}

export function readConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function persistConsent(state) {
  try {
    localStorage.setItem(
      CONSENT_STORAGE_KEY,
      JSON.stringify({ ...state, updatedAt: new Date().toISOString() }),
    );
  } catch (e) {
    /* ignore */
  }
}

export function applyConsent(state) {
  const full = { ...DEFAULT_CONSENT, ...state };
  pushGtagConsent(full);
  persistConsent(full);
  return full;
}

export function acceptAll() {
  return applyConsent({
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
  });
}

export function rejectAll() {
  return applyConsent({
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    personalization_storage: "denied",
    security_storage: "granted",
  });
}

export function saveCustom(prefs) {
  // prefs: { analytics: bool, marketing: bool, functional: bool }
  return applyConsent({
    ad_storage: prefs.marketing ? "granted" : "denied",
    ad_user_data: prefs.marketing ? "granted" : "denied",
    ad_personalization: prefs.marketing ? "granted" : "denied",
    analytics_storage: prefs.analytics ? "granted" : "denied",
    functionality_storage: prefs.functional ? "granted" : "denied",
    personalization_storage: prefs.functional ? "granted" : "denied",
    security_storage: "granted",
  });
}

export function hasStoredConsent() {
  return readConsent() !== null;
}
